import React from 'react';
import PropTypes from 'prop-types';
import styles from './ToggleSwitch.module.css';

const ToggleSwitch = ({ active, clickHandler }) => (
  <label
    aria-label="switch"
    className={`${styles.switch} ${active ? styles.active : ''}`}
  >
    <input type="checkbox" checked={active} onChange={clickHandler} />
    <span className={`${styles.slider}`} />
  </label>
);

ToggleSwitch.propTypes = {
  active: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired,
};

export default ToggleSwitch;
